export const recommendationTemplate = `
  <li>
    <a href="{{{link_origin}}}/{{module_name}}" data-term="{{name}}" data-module-name="{{module_name}}" data-brand-color="{{brand_color}}" data-image="{{image}}">
      <div class="recent-search-icon" style="background-color: {{brand_color}}">
        <img src="{{image}}" alt="{{name}}" title="{{name}}" width="24" height="24" loading="lazy">
      </div>
      <span class="recent-search-text">{{name}}</span>
      <div class="recent-search-result-type">Service</div>
    </a>
  </li>
`
export const searchHistoryTemplate = `
  <li>
    <a href="{{{link_origin}}}/search/query/{{query_term}}" data-term="{{term}}">
      <div class="recent-search-icon search-svg"></div>
      <span class="recent-search-text">{{term}}</span>
    </a>
  </li>
`
